module.exports = __webpack_public_path__ + "img/kosala.5cb7cc31.jpg";